import { serviceProvider } from '@yola/subscription-manager-js';
import { errors } from '@yola/ws-sdk';
import user from 'yola-editor/src/js/modules/user';

const fetchEcommercePlans = () => async (dispatch, getState) => {
  const state = getState();
  const availableSubscriptionTypes = user.selectors.getAvailableSubscriptionTypes(state);

  try {
    await serviceProvider.fetchEcommercePlans(availableSubscriptionTypes);
  } catch (error) {
    errors.operations.catchError(error);
  }
};

export default fetchEcommercePlans;
